import { ILocalBranch } from '@models/localBranch';

export class Create {
	static readonly type = '[localBranch] create localBranch against business';

	constructor(
		public localBranch: ILocalBranch,
		public mortgageId?: string,
	) {}
}

export class Remove {
	static readonly type = '[localBranch] remove localBranch from business';

	constructor(public localBranchId: string) {}
}

export class UpdateLocalBranch {
	static readonly type = '[localBranch] update local branch';
	constructor(public payload: ILocalBranch) {}
}
